export default "__VITE_ASSET__DGe3krsu__"